import {getLineNumberWidth} from '@github-ui/diffs/diff-line-helpers'
import {UnifiedDiffLines} from '@github-ui/diffs/DiffParts'
import {clsx} from 'clsx'

import type {StaticDiffLine} from '../../conversation-types'
import styles from './StaticUnifiedDiffPreview.module.css'

type StaticUnifiedDiffPreviewProps = {
  diffLines?: StaticDiffLine[]
  tabSize: number
  className?: string
  diffTableClassName?: string
}

/**
 * Renders a static representation of a unified diff
 * Specifically for use in outdated threads, which return a slightly different set of difflines
 */
export function StaticUnifiedDiffPreview({
  diffLines,
  tabSize,
  className,
  diffTableClassName,
}: StaticUnifiedDiffPreviewProps) {
  if (!diffLines || diffLines.length < 1) {
    return null
  }

  const lineWidth = getLineNumberWidth(diffLines)

  // Stop copy events from bubbling to the outer DiffLines table, whose onCopy handler
  // (packages/diff-lines/components/DiffLines.tsx) filters content by literal class names
  // (`td.diff-text-cell`, `td.diff-line-number`, etc.). This preview uses CSS-module
  // hashed class names instead, so the outer handler would strip everything and leave
  // the clipboard empty when copying multi-line selections from this mini-diff (e.g. an
  // ARC suggestion's diff preview, or an outdated review thread). See:
  // https://github.com/github/copilot-code-review/issues/2180
  return (
    <div className={clsx(styles.StaticDiffPreview, className)} onCopy={e => e.stopPropagation()}>
      <UnifiedDiffLines lineWidth={lineWidth} lines={diffLines} tabSize={tabSize} className={diffTableClassName} />
    </div>
  )
}
